// src/redux/sessionMaster/sessionMasterAPI.js
import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Add Session Master
export const addSessionMasterAPI = async (data) => {
  try {
    const response = await apiService.post(endpoints.addSessionMaster, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Update Session Master
export const updateSessionMasterAPI = async ({ id, data }) => {
  try {
    const response = await apiService.put(`${endpoints.updateSessionMaster}/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Session Master List (Updated with access_group_id and archived parameter)
export const getSessionMasterListAPI = async ({ 
  page = 1, 
  limit = 10, 
  search = "", 
  access_group_id = null,
  archived
} = {}) => {
  try {
    const params = { page, limit, search ,access_group_id ,archived};
  
    const response = await apiService.get(endpoints.getSessionMasterList, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Session Master Detail
export const getSessionMasterByIdAPI = async (id) => {
  try {
    const response = await apiService.get(`${endpoints.getSessionMasterById}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Archive Session Master (Updated from delete to archive)
export const archiveSessionMasterAPI = async (id, is_archive = true) => {
  try {
    const response = await apiService.patch(`${endpoints.archiveSessionMaster}/${id}`, {
      is_archive
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Tool List
export const ToolAPI = async () => {
  try {
    const response = await apiService.get("/tools");
    return response.data;
  } catch (error) {
    throw error;
  }
};